import React from "react";
import { FlexBox, Listbox, ListboxButton, ListboxList, ListboxOption, ListboxPopover, ListboxSection, Typography, useId, } from "@vp/swan";
import { DropdownCallout } from "../dropdown-callout";
import { incompatibleMessage } from "../incompatible-message";
import { OptionPriceDisplay } from "../../../../shared/options-price-display";
import { encodeKey } from "../../helpers";
import { ListboxPlaceholder } from "./shared/listbox-placeholder";
import { useProductOptionsTranslations } from "../../../../product-options-translations";
import { useListboxSelectionHelper } from "../../../../../hooks/use-listbox-selection-helper";
import { SimpleTitle } from "../../../../shared/simple-title";
export const MinimalDropdownSkin = (props) => {
    const { option, onChanged, showIncompatibleChoices, fractionDigits, locale, currency, priceDisplayMode = "none", tenant, } = props;
    const { i18n } = useProductOptionsTranslations();
    const titleId = useId();
    const compatibleChoices = option.choices.filter((choice) => choice.isCompatible);
    const { selectedKeys, handleOnSelectionChange } = useListboxSelectionHelper(option.selectedKey, onChanged);
    let incompatibleChoices = [];
    if (showIncompatibleChoices) {
        incompatibleChoices = option.choices.filter((choice) => !choice.isCompatible);
    }
    const renderChoice = (choice, showCallout) => {
        const label = (React.createElement(React.Fragment, null,
            React.createElement(Typography, null, choice.name),
            React.createElement(OptionPriceDisplay, { tenant: tenant, choice: choice, fractionDigits: fractionDigits, priceDisplayMode: priceDisplayMode, locale: locale, currency: currency, hideZeroPrice: true })));
        return (React.createElement(ListboxOption, { key: encodeKey(choice.key), textValue: choice.name, disabled: choice.isOutOfStock, label: React.createElement(FlexBox, { flexDirection: "row", gap: "3", fontWeight: "bold" }, label) },
            React.createElement(FlexBox, { gap: "3", alignItems: "baseline" },
                label,
                showCallout && React.createElement(DropdownCallout, { callouts: choice.callouts }))));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(SimpleTitle, { titleId: titleId }),
        React.createElement(Listbox, { selectionMode: "single", fullWidth: true, selectedKeys: selectedKeys, onSelectionChange: handleOnSelectionChange, size: "standard", "aria-required": option.isRequired },
            React.createElement(ListboxButton, { "aria-labelledby": titleId, placeholder: React.createElement(ListboxPlaceholder, null) }),
            React.createElement(ListboxPopover, null,
                React.createElement(ListboxList, null,
                    React.createElement(ListboxSection, null, compatibleChoices.map((choice) => renderChoice(choice, true))),
                    showIncompatibleChoices && incompatibleChoices.length > 0
                        ? incompatibleMessage(i18n)
                        : [],
                    incompatibleChoices.map((choice) => renderChoice(choice, false)))))));
};
//# sourceMappingURL=minimal-dropdown-skin.js.map